import React, { useEffect, useState, useCallback } from "react";
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MyTextField from '../../utils/MyTextField';
import MyTable from '../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import DeleteIcon from '@material-ui/icons/Delete';

import _ from 'lodash';

import moment from 'moment';

//redux
import { useSelector, useDispatch } from 'react-redux'
import allActions from '../../../actions'

import { unoTheme } from '../../../assets/styles/unoTheme'


import { applyMaskAmount, applyMaskAccount, getOperationLabel } from "../../utils/utils";

import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { checkUserIsRole, roles } from "../../utils/user";
import { Checkbox, IconButton } from "@material-ui/core";
import ConfirmActionModal from "../../modals/ConfirmActionModal";
import { useMemo } from "react";

const useStyles = makeStyles((theme) => ({
    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.errorColor,
    },

    blue: {
        color: 'blue',
    },

    ok: {
        color: unoTheme.greenMoney,

        fontSize: '1.2em',

    },
    pendent: {
        color: unoTheme.warningColor,

        fontSize: '1.2em',

    },

    invalidTransaction: {
        background: '#ff7878 !important',
    }
}));

export default function TransactionsTable(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { transactions, clientAccounts, clientFunds, clientAssets, clientOperations, doDeleteTransactions, unableToChange } = props;

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)

    const [openConfirmActionModal, setOpenConfirmActionModal] = useState(false);
    const [checkedTransactions, setCheckedTransactions] = useState([]);
    const handleCheckTransation = (event, index) => {

        const newCheckeds = [...checkedTransactions]
        newCheckeds[index] = event.target.checked;
        setCheckedTransactions(newCheckeds);
    }

    const cleanChecked = () => {

        const newCheckeds = [...checkedTransactions]
        newCheckeds.forEach((element, index) => {
            newCheckeds[index] = false;
        })
        setCheckedTransactions(newCheckeds);
    }

    const getIdsTransactionsToDelete = (checkeds) => {

        const tToDelete = [];
        transactions.forEach((element, index) => {
            if (checkeds[index] == true) {
                tToDelete.push(element.id);
            }
        });

        return tToDelete;
    }

    const checkIsAbleToUpdate = useMemo(() => {
        if (!currentUser) return false;
        return checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.advisor])
            || (clientOn?.client?.is_able_transactions_current_month
                && (moment.utc(new Date()).format("M/YYYY") == (parseInt(clientOn.client.selectedMonth) + '/' + clientOn.client.selectedYear))
                && checkUserIsRole(currentUser, [roles.manager, roles.submanager]))
    }, [currentUser]);

    return (
        <>

            <MyTable
                stickyHeader
                selectable="true"
                size="small">
                <colgroup>
                    <col width="5%" />
                    <col width="10%" />
                    <col width="35%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="25%" />
                    <col width="10%" />
                </colgroup>
                <TableHead>
                    <TableRow>
                        <TableCell align='center'>
                            {
                                checkedTransactions.find(e => e == true) && !unableToChange &&
                                <IconButton style={{ color: unoTheme.redMoney }}
                                    onClick={() => setOpenConfirmActionModal(true)}>
                                    <DeleteIcon />
                                </IconButton>
                            }
                        </TableCell>
                        <TableCell align='center'>Data</TableCell>
                        <TableCell align='left'>Fundo</TableCell>
                        <TableCell align='center'>Operação</TableCell>
                        <TableCell align="center">Conta</TableCell>
                        <TableCell align='right'>Valor</TableCell>
                        <TableCell align="center">APR</TableCell>
                    </TableRow>
                </TableHead>
                {transactions ?
                    <TableBody>
                        {transactions.map((transactionRow, index) => (
                            <TableRow
                                className={transactionRow.invalidTransaction ? classes.invalidTransaction : null}
                                key={'apr-transaction-' + index}
                                onClick={() =>
                                    //Verificar role
                                    checkIsAbleToUpdate ?

                                        dispatch(allActions.rightContentActions.setRightContent({
                                            path: 'newTransaction',
                                            update: true,
                                            transactionToUpdate: transactionRow,
                                            data: {
                                                accounts: clientAccounts,
                                                funds: clientFunds,
                                                assets: clientAssets,
                                                operations: clientOperations,
                                            }
                                        }))
                                        : null
                                }>
                                <TableCell align="center" className='noPaddingCell'>
                                    <Checkbox
                                        disabled={unableToChange}
                                        checked={checkedTransactions[index] === true}
                                        color="primary"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                        }}
                                        onChange={(e) => {
                                            handleCheckTransation(e, index)
                                        }}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </TableCell>
                                <TableCell align="center">{moment.utc(transactionRow.transaction_date).format("DD/MM/YYYY")}</TableCell>
                                <TableCell align="left">{transactionRow.fund_name}</TableCell>
                                <TableCell align="center">{getOperationLabel(transactionRow)}</TableCell>
                                <TableCell align="center">{applyMaskAccount(transactionRow.account)}</TableCell>
                                <TableCell align="right" className={
                                    transactionRow.operation == 'Aplicação' ? classes.green : (
                                        transactionRow.operation == 'Resgate' ? classes.red : classes.blue
                                    )
                                }>{applyMaskAmount(transactionRow.amount, true)}</TableCell>
                                <TableCell
                                    align="center">
                                    {
                                        transactionRow.apr_description_id || (transactionRow.apr_description != "" && transactionRow.apr_description != null) ?

                                            <CheckCircleIcon className={classes.ok} style={{ verticalAlign: 'middle' }} />
                                            :
                                            <ReportProblemIcon className={classes.pendent} style={{ verticalAlign: 'middle' }} />
                                    }

                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    :
                    null
                }

            </MyTable>
            <ConfirmActionModal
                open={openConfirmActionModal}
                title={'Excluir movimentações'}
                message={`Tem certeza de que deseja excluir ${checkedTransactions.filter(e => e == true).length} movimentações selecionadas?`}
                handleAction={(action) => {
                    if (action) {
                        doDeleteTransactions(getIdsTransactionsToDelete(checkedTransactions))
                    }
                    cleanChecked();
                    setOpenConfirmActionModal(false)
                }}>
            </ConfirmActionModal>
        </>
    );
}



